/**
 * An awaited `form.validateFields()` rejects with antd's `{ errorFields, values, outOfDate }`
 * when a field is invalid. The form already shows the inline error, so the rejection is expected
 * flow, not a crash.
 */
export const FORM_VALIDATION_ERROR_PATTERNS = [/Object captured as promise rejection with keys: errorFields/];

/**
 * The Redux state attached to every Sentry event. Only UI state and the ids of the current
 * tenant: the entity slices and RTK Query caches hold owner, customer and bank details.
 */
export function sentryReduxState(state) {
  if (!state) {
    return null;
  }

  return {
    activeTab: state.activeTab,
    appStatus: state.appStatus,
    sideBar: state.sideBar,
    currentCompanyId: state.currentCompany?.company?.id ?? null,
    currentFranchiseId: state.currentFranchise?.franchise?.id ?? null,
    currentServiceProviderId: state.currentServiceProvider?.serviceProvider?.id ?? null,
  };
}
